export default "__VITE_ASSET__8b8ba814__"